import { EntityType } from '@frontend/common';
import { NotificationTemplateClient } from '@frontend/notification/api';
import { CreateNotificationTemplate, NotificationTemplate } from '@frontend/notification/types';
import { FormattedMessage } from 'react-intl';

import CreateModal from '../../../../modal/create-modal/create-modal.component';
import { useCreateTemplateModal } from './create-template-modal.controller';

export const CreateTemplateModal = () => {
    const viewProps = useCreateTemplateModal();

    return (
        <CreateModal<NotificationTemplate, CreateNotificationTemplate>
            order={['name', 'description']}
            required={['name']}
            expectedType={new Map([['description', 'textarea']])}
            type={EntityType.NOTIFICATION_TEMPLATE}
            onSubmit={(v) => NotificationTemplateClient.postNotificationTemplate(viewProps.currentAccount, v)}
            formId={viewProps.templateModalId}
            label={
                <FormattedMessage
                    id='notifications.templates.create-template'
                    defaultMessage='Create notification template'
                />
            }
        />
    );
};
